import { useLoader } from '@/hooks/use_loader';
import { campaign } from '@/json/json_loader';
import { ActionBase } from '@/models/action_base';
import { KbnConst } from '@/utils/kbn';
import { sleep } from '@/utils/sleep';

import { useApi } from './use_api';
import { useFileUpload } from './use_file_upload';
import { useInsertDataStore } from './use_insert_data_store';
import { useRouting } from './use_routing';
import { useSurvey } from './use_survey';
import { useTrackingId } from './use_tracking_id';
export class ActionReceiptUpload extends ActionBase {
  typeKbn = KbnConst.ACTION_TYPE_KBN_RECEIPT_UPLOAD;

  use() {
    const insertDataStore = useInsertDataStore();
    const survey = useSurvey();
    const routing = useRouting();
    return async () => await execute(
      insertDataStore,
      survey,
      routing,
    );

  }

  constructor(init: Partial<ActionReceiptUpload> = {}) {
    super();
    Object.assign(this, init);
  }
}

export async function execute(
  insertDataStore: ReturnType<typeof useInsertDataStore>,
  survey: ReturnType<typeof useSurvey>,
  routing: ReturnType<typeof useRouting>,
) {
  const loader = useLoader();
  const api = useApi();
  const { fileCache } = useFileUpload();

  if (!fileCache.value) return true; // ファイルが無い場合はアクション中断
  // surveyデータがある、かつ全てのアンケート回答が空ではない
  const surveyData = survey.getPostData();
  if (surveyData && !surveyData?.isAllEmptyAnswer()) {
    insertDataStore.survey.value = surveyData;
  }
  loader.start();
  try {
    const { presignedUrl, receiptUuid } = (await api.getReceiptUploadUrl()).dataJson;
    await api.uploadFile(presignedUrl, fileCache.value, { 'x-amz-acl': 'public-read' });
    const insertDataStore = useInsertDataStore();
    const trackingId = useTrackingId();
    await api.postReceipt(receiptUuid, {
      purchaseStore: insertDataStore.purchaseStore.value,
      purchaseItem: insertDataStore.purchaseItem.value,
      selectedItem: insertDataStore.selectedItem.value,
      survey: insertDataStore.survey.value,
      trackingId: trackingId.value,
    });
    const entryPollingResponse = await api.getEntryPolling(receiptUuid);
    if (entryPollingResponse && entryPollingResponse.responseCandidateUuid) {
      const uuid = entryPollingResponse.responseCandidateUuid;
      const page = campaign.responseCandidates.find(x => x.uuid === uuid)?.pageName;
      if (page) {
        await routing.redirect(page);
        fileCache.value = undefined;
        return true;
      }
    }

    // 返信グループに落ちなかった場合エラーページに遷移
    fileCache.value = undefined;

    // receiptUuid.value = null;
    await routing.redirect('error');
  } finally {
    loader.stop();
  }

  return false;
}
